'use client';

import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';

export function HubSpotIdentityBinding() {
  const user = useAuthStore((state) => state.user);
  const email = user?.user?.email ?? null;

  useEffect(() => {
    if (typeof window === 'undefined' || !email) return;

    const identifyUser = () => {
      if (window._hsq) {
        window._hsq.push([
          'identify',
          {
            email,
          },
        ]);
        window._hsq.push(['trackPageView']);
      }
    };

    // Try immediately in case _hsq is already available
    if (window._hsq) {
      identifyUser();
      return;
    }

    // Otherwise, poll for _hsq availability
    const checkInterval = setInterval(() => {
      if (window._hsq) {
        identifyUser();
        clearInterval(checkInterval);
      }
    }, 100);

    // Cleanup after 10 seconds
    const timeout = setTimeout(() => {
      clearInterval(checkInterval);
    }, 10000);

    return () => {
      clearInterval(checkInterval);
      clearTimeout(timeout);
    };
  }, [email]);

  return null;
}
